module.exports = __webpack_public_path__ + "img/process_take_now.47837ad3.svg";